import { Typography, Grid, Box, Link } from '@mui/material';

import { storage } from '@goldblack/client-storage';

function UnauthorizedBody() {
    const onClickLogin = () => {
        storage.transience.setState('path.gateway', 'login');
    };

    return (
        <Box sx={{ height: '100%', display: 'grid', placeItems: 'center' }}>
            <Grid container spacing={0} direction='column' justifyContent='center' alignItems='center'>
                <Typography align='center' variant='m_logo' color='primary.main' sx={{ mb: '0.6em' }}>
                    Loise
                </Typography>
                <Typography
                    align='center'
                    variant='m_overline'
                    color='primary.main'
                    sx={{ mb: 'clamp(32px, 4vh, 64px' }}>
                    administrator tool
                </Typography>
                <Typography align='center' variant='body1' sx={{ mt: 4 }}>
                    Access Denied
                </Typography>
                <Typography align='center' variant='body2' color='text.secondary' sx={{ mt: 1 }}>
                    You do not have permission to access this page.
                </Typography>
                <Box sx={{ mt: 4 }}>
                    <Link onClick={onClickLogin} variant='body2' component='button'>
                        Login
                    </Link>
                </Box>
            </Grid>
        </Box>
    );
}

export { UnauthorizedBody };
